module.exports = __webpack_public_path__ + "static/media/bigbang.43c9d815.mp3";